import { createRouter, createWebHashHistory  } from 'vue-router'
import MainLayout from '../layouts/MainLayout.vue'
import { PageView } from '../utils/analytics'

const routes = [
  {
    path: '/',
    component: MainLayout,
    redirect: { name: 'Inicio' },
    children: [
      {
        path: '/inicio',
        name: 'Inicio',
        component: () => import(/* webpackChunkName: "Inicio" */ '../views/Inicio.vue')
      },
      {
        path: '/conteudos',
        name: 'Conteudos',
        component: () => import(/* webpackChunkName: "conteudo" */ '../views/Conteudos.vue')
      },
      {
        path: '/galeria',
        name: 'Galeria',
        component: () => import(/* webpackChunkName: "galeria" */ '../views/Galeria.vue')
      },
      {
        path: '/contato',
        name: 'Contato',
        component: () => import(/* webpackChunkName: "contato" */ '../views/Contato.vue')
      },
      {
        path: '/sobre',
        name: 'Sobre',
        component: () => import(/* webpackChunkName: "sobre" */ '../views/Sobre.vue')
      },
      {
        path: '/quiz',
        name: 'Quiz',
        component: () => import(/* webpackChunkName: "quiz" */ '../views/Quiz.vue')
      }
    ]
  }
]

const router = createRouter({
  mode: 'history',
  history: createWebHashHistory(),
  routes
})

router.afterEach((to, from, failure) => {
  if (!failure) PageView.view({ title: to.name, path: to.fullPath })
})

export default router
